
                                        // "imageGridCards": {
                                    export  const imageGridCards = [{
                                                "id": "2568016",
                                                "imageId": "PC_Mweb/Pizza.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/83631?collection_id=83631&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
                                                    "text": "Pizzas",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurants curated for pizza",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/83631?collection_id=83631&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568349",
                                                "imageId": "PC_Mweb/Samosa.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80396?collection_id=80396&type=rcv2",
                                                    "text": "Samosa",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurants curated for samosa",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80396?collection_id=80396&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568574",
                                                "imageId": "PC_Mweb/Burger.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
                                                    "text": "Burgers",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurants curated for burger",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568034",
                                                "imageId": "PC_Mweb/Rolls.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/83669?collection_id=83669&tags=layout_CCS_Rolls&type=rcv2",
                                                    "text": "Rolls",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurants curated for roll",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/83669?collection_id=83669&tags=layout_CCS_Rolls&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568353",
                                                "imageId": "PC_Mweb/Momo.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80461?collection_id=80461&tags=layout_CCS_Momos&type=rcv2",
                                                    "text": "Momos",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for momos",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80461?collection_id=80461&tags=layout_CCS_Momos&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568346",
                                                "imageId": "PC_Mweb/Noodles.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80463?collection_id=80463&type=rcv2",
                                                    "text": "Noodles",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for noodles",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80463?collection_id=80463&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568345",
                                                "imageId": "PC_Mweb/Vada%20Pav.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80417?collection_id=80417&type=rcv2",
                                                    "text": "Vada Pav",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurants curated for vada pav",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80417?collection_id=80417&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568041",
                                                "imageId": "PC_Mweb/Pasta.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80479?collection_id=80479&type=rcv2",
                                                    "text": "Pasta",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for pasta",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80479?collection_id=80479&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568317",
                                                "imageId": "PC_Mweb/Dhokla.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80422?collection_id=80422&type=rcv2",
                                                    "text": "Dhokla",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurants curated for dhokla",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80422?collection_id=80422&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568142",
                                                "imageId": "PC_Mweb/Dosa.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80424?collection_id=80424&tags=layout_CCS_Dosa&type=rcv2",
                                                    "text": "Dosa",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurants curated for dosa",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80424?collection_id=80424&tags=layout_CCS_Dosa&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568312",
                                                "imageId": "PC_Mweb/Cake.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/83655?collection_id=83655&tags=layout_CCS_Cake&type=rcv2",
                                                    "text": "Cakes",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for cake",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/83655?collection_id=83655&tags=layout_CCS_Cake&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568341",
                                                "imageId": "PC_Mweb/Pastry.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80355?collection_id=80355&type=rcv2",
                                                    "text": "Pastry",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for Pastry",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80355?collection_id=80355&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568337",
                                                "imageId": "PC_Mweb/Pav%20Bhaji.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80362?collection_id=80362&tags=layout_PavBhaji_Contextual&type=rcv2",
                                                    "text": "Pav Bhaji",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for pav bhaji",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80362?collection_id=80362&tags=layout_PavBhaji_Contextual&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568339",
                                                "imageId": "PC_Mweb/Biryani.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/83639?collection_id=83639&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
                                                    "text": "Biryani",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurants curated for biryani",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/83639?collection_id=83639&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568600",
                                                "imageId": "PC_Mweb/Pakoda.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80469?collection_id=80469&type=rcv2",
                                                    "text": "Pakoda",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for pakoda",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80469?collection_id=80469&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568015",
                                                "imageId": "PC_Mweb/Chole%20Bhature.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80382?collection_id=80382&tags=layout_CCS_CholeBhature&type=rcv2",
                                                    "text": "Chole Bhature",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for chhole bhatoore",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80382?collection_id=80382&tags=layout_CCS_CholeBhature&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568039",
                                                "imageId": "PC_Mweb/Salad.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80394?collection_id=80394&tags=layout_CCS_Salad&type=rcv2",
                                                    "text": "Salad",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for salad",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80394?collection_id=80394&tags=layout_CCS_Salad&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568338",
                                                "imageId": "PC_Mweb/Patty.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80360?collection_id=80360&type=rcv2",
                                                    "text": "Patty",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for patty",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80360?collection_id=80360&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568370",
                                                "imageId": "PC_Mweb/Shake.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/83673?collection_id=83673&tags=layout_CCS_Shakes&type=rcv2",
                                                    "text": "Shake",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurants curated for shakes",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/83673?collection_id=83673&tags=layout_CCS_Shakes&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568009",
                                                "imageId": "PC_Mweb/Chinese.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/83636?collection_id=83636&tags=layout_CCS_Chinese&type=rcv2",
                                                    "text": "Chinese",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for chinese",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/83636?collection_id=83636&tags=layout_CCS_Chinese&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }]